import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { loginClientAdmin } from "../services/clientAdminApi";

const TOKEN_KEY = "clientAdminToken";
const CLIENT_ID_KEY = "clientAdminId";
const ClientAdminAuthContext = createContext(null);

export function ClientAdminAuthProvider({ children }) {
  const [token, setToken] = useState(() => localStorage.getItem(TOKEN_KEY));
  const [clientId, setClientId] = useState(() => localStorage.getItem(CLIENT_ID_KEY));

  const login = useCallback(async (credentials) => {
    const { data } = await loginClientAdmin(credentials);
    localStorage.setItem(TOKEN_KEY, data.access_token);
    localStorage.setItem(CLIENT_ID_KEY, credentials.clientId);
    setToken(data.access_token);
    setClientId(credentials.clientId);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(CLIENT_ID_KEY);
    setToken(null);
    setClientId(null);
  }, []);

  const value = useMemo(
    () => ({ token, clientId, login, logout, isAuthenticated: Boolean(token) }),
    [token, clientId, login, logout],
  );

  return (
    <ClientAdminAuthContext.Provider value={value}>
      {children}
    </ClientAdminAuthContext.Provider>
  );
}

export const useClientAdminAuth = () => {
  const context = useContext(ClientAdminAuthContext);
  if (!context) throw new Error("useClientAdminAuth must be used within ClientAdminAuthProvider");
  return context;
};
